function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import * as Yup from "yup";
import { Field, Form as FormikForm, Formik } from "formik";
import Form from "react-bootstrap/Form";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import "./ManualPages.css";
import Loader from "./../Loader/Loader";
import { FilterContext, UserContext, TrackingContext } from "../index";
import classNames from "classnames";
import ProjectAndTaskList from "./ProjectAndTaskList";
import DesktopProjectList from "./DesktopProjectList";
import DesktopTaskList from "./DesktopTaskList";
import ManualPages from "./ManualPages";
import Dropdown from "react-bootstrap/Dropdown";
import { ADD_TIMER_MUTATION, PROJECTS_LISTING_QUERY, ADD_MANUAL_MUTATION, GET_TASK_TRACKER_QUERY, END_TIMER_MUTATION } from "./query";
import { useQuery, useMutation } from "@apollo/client";
import { toast } from "react-toastify";
var TimerSchema = Yup.object().shape({
  description: Yup.string().trim().required("Required")
});
var ManualSchema = Yup.object().shape({
  manualdescription: Yup.string().trim().required("Required"),
  manualStartTime: Yup.string().required("Required"),
  manualEndTime: Yup.string().required("Required")
});
var EditSchema = Yup.object().shape({
  editdescription: Yup.string().trim().required("Required"),
  startTime: Yup.string().required("Required"),
  endTime: Yup.string().required("Required")
});
var ManualModalSchema = Yup.object().shape({
  taskDescription: Yup.string().trim().required("Required"),
  startTime: Yup.string().trim().required("Required"),
  endTime: Yup.string().trim().required("Required")
});
var LIMIT = 10;
var offsets = 0;
var MANUAL_LIMIT = 10;
var manualOffsets = 0;
var DesktopTaskTimer = function DesktopTaskTimer(props) {
  var _taskTrackerData$getT13, _taskTrackerData$getT14, _props$task, _props$task$projectDe, _taskTrackerData$getT15, _taskTrackerData$getT16, _taskTrackerData$getT17;
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(TrackingContext),
    task = _React$useContext2.task;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    ManualViewerShow = _React$useState2[0],
    setManualViewerShow = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isNavClick = _React$useState4[0],
    setNavClick = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isTaskClick = _React$useState6[0],
    setTaskClick = _React$useState6[1];
  var _React$useState7 = React.useState(task !== null && task !== void 0 && task.projectId ? {
      projectId: task === null || task === void 0 ? void 0 : task.projectId,
      projectName: task === null || task === void 0 ? void 0 : task.projectName,
      taskId: task === null || task === void 0 ? void 0 : task.taskId,
      taskName: task === null || task === void 0 ? void 0 : task.taskName
    } : null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    addedShow = _React$useState8[0],
    setAddedShow = _React$useState8[1];
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    manualAddedShow = _React$useState10[0],
    setManualAddedShow = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    disableStartTask = _React$useState12[0],
    setDisableStartTask = _React$useState12[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isShown = _React$useState14[0],
    setIsShown = _React$useState14[1];
  var _React$useState15 = React.useState(new Date()),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    taskStartDate = _React$useState16[0],
    setTaskStartDate = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isTaskDatePickerOpen = _React$useState18[0],
    setIsTaskDatePickerOpen = _React$useState18[1];
  var _React$useState19 = React.useState("timer"),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isToggleShow = _React$useState20[0],
    setIsToggleShow = _React$useState20[1];
  var _React$useState21 = React.useState(new Date()),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    manualStartDate = _React$useState22[0],
    setManualStartDate = _React$useState22[1];
  var _React$useState23 = React.useState(false),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    isManualDatePickerOpen = _React$useState24[0],
    setIsManualDatePickerOpen = _React$useState24[1];
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    isNavClickProject = _React$useState26[0],
    setNavClickProject = _React$useState26[1];
  var _React$useState27 = React.useState(null),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    addedShowProject = _React$useState28[0],
    setAddedShowProject = _React$useState28[1];
  var _React$useState29 = React.useState(false),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    projectError = _React$useState30[0],
    setProjectError = _React$useState30[1];
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    descriptionError = _React$useState32[0],
    setdescriptionError = _React$useState32[1];
  var _React$useState33 = React.useState([]),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    userIds = _React$useState34[0],
    setUserIds = _React$useState34[1];
  var _React$useState35 = React.useState([]),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    projectIds = _React$useState36[0],
    setProjectIds = _React$useState36[1];
  var _React$useState37 = React.useState([]),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    taskIds = _React$useState38[0],
    setTaskIds = _React$useState38[1];

  //loadmore
  var _React$useState39 = React.useState(false),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    isAllLoaded = _React$useState40[0],
    setIsAllLoaded = _React$useState40[1];
  var _React$useState41 = React.useState(false),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    isLoadingMore = _React$useState42[0],
    setIsLoadingMore = _React$useState42[1];
  var _React$useState43 = React.useState(false),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    isLoadMoreButton = _React$useState44[0],
    setIsLoadMoreButton = _React$useState44[1];
  var _React$useState45 = React.useState(""),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    modalStartTime = _React$useState46[0],
    setModalStartTime = _React$useState46[1];
  var _React$useState47 = React.useState(""),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    modalEndTime = _React$useState48[0],
    setModalEndTime = _React$useState48[1];
  var _React$useState49 = React.useState(undefined),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    modalValueStartTime = _React$useState50[0],
    setModalValueStartTime = _React$useState50[1];
  var _React$useState51 = React.useState(undefined),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    modalValueEndTime = _React$useState52[0],
    setModalValueEndTime = _React$useState52[1];
  var _React$useState53 = React.useState(""),
    _React$useState54 = _slicedToArray(_React$useState53, 2),
    modalManualStartTime = _React$useState54[0],
    setModalManualStartTime = _React$useState54[1];
  var _React$useState55 = React.useState(""),
    _React$useState56 = _slicedToArray(_React$useState55, 2),
    modalManualEndTime = _React$useState56[0],
    setModalManualEndTime = _React$useState56[1];
  var _React$useState57 = React.useState(undefined),
    _React$useState58 = _slicedToArray(_React$useState57, 2),
    modalManualValueStartTime = _React$useState58[0],
    setModalManualValueStartTime = _React$useState58[1];
  var _React$useState59 = React.useState(undefined),
    _React$useState60 = _slicedToArray(_React$useState59, 2),
    modalManualValueEndTime = _React$useState60[0],
    setModalManualValueEndTime = _React$useState60[1];
  var _React$useState61 = React.useState(null),
    _React$useState62 = _slicedToArray(_React$useState61, 2),
    userParameterCheck = _React$useState62[0],
    setUserParameterCheck = _React$useState62[1];
  var _React$useState63 = React.useState(null),
    _React$useState64 = _slicedToArray(_React$useState63, 2),
    projectParameterCheck = _React$useState64[0],
    setProjectParameterCheck = _React$useState64[1];
  var _React$useState65 = React.useState(null),
    _React$useState66 = _slicedToArray(_React$useState65, 2),
    taskParameterCheck = _React$useState66[0],
    setTaskParameterCheck = _React$useState66[1];
  var projectList = [{
    label: "All Project",
    value: ""
  }];
  var taskList = [{
    label: "All Task",
    value: ""
  }];
  var userList = [{
    label: "All Member",
    value: ""
  }];
  var _React$useContext3 = React.useContext(FilterContext),
    teamId = _React$useContext3.teamId,
    organisationId = _React$useContext3.organisationId,
    organisationUserCount = _React$useContext3.organisationUserCount,
    startDate = _React$useContext3.startDate,
    endDate = _React$useContext3.endDate,
    organisationSettings = _React$useContext3.organisationSettings,
    role = _React$useContext3.role;
  var formRef = React.useRef();
  var _useQuery = useQuery(PROJECTS_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        from: "desktop"
      },
      skip: !organisationId || !teamId
    }),
    projectListing = _useQuery.data,
    projectListingError = _useQuery.error,
    projectListingLoading = _useQuery.loading,
    projectRefetch = _useQuery.refetch;
  var _useQuery2 = useQuery(GET_TASK_TRACKER_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userId: props !== null && props !== void 0 && props.from ? [props === null || props === void 0 ? void 0 : props.userId] : userIds.length ? userIds : null,
        projectId: projectIds.length ? projectIds : null,
        taskId: taskIds.length ? taskIds : null,
        limit: LIMIT,
        offset: 0
      },
      skip: !teamId || !organisationId
    }),
    taskTrackerData = _useQuery2.data,
    taskTrackerError = _useQuery2.error,
    taskTrackerLoading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore,
    taskRefetch = _useQuery2.refetch;
  React.useEffect(function () {
    if (!window.ipcRenderer) return;
    if (task && organisationSettings !== null && organisationSettings !== void 0 && organisationSettings.projectManagement && !(task !== null && task !== void 0 && task.projectId)) {
      taskRefetch();
      projectRefetch();
    }

    //   if (!props.task) return;
    //   console.log(props?.task);
    //   const { projectId, taskId, description, taskDescription, taskStartTime, taskTimeId } = props?.task;

    //   const values = { description:  description || taskDescription, taskStartTime, taskTimeId };
    //   const addedShow = { projectId, taskId };
    //   console.log("Electron sub Project Stop Call");
    //     window.ipcRenderer.on(
    //       "clock_out_project",
    //       handleStopProjectTaskTimer(values, addedShow, formRef.resetForm, formRef.setStatus)
    //     );
    window.ipcRenderer.on("refresh_project_details", taskRefetch);
  }, []);
  React.useEffect(function () {
    taskRefetch();
    projectRefetch();
  }, [userIds, projectIds, taskIds]);
  React.useEffect(function () {
    if (taskTrackerData && !taskTrackerLoading) {
      var _taskTrackerData$getT, _taskTrackerData$getT4;
      if (taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getT = taskTrackerData.getTaskTrackerDetails) !== null && _taskTrackerData$getT !== void 0 && _taskTrackerData$getT.endNowButton[0]) {
        var _taskTrackerData$getT3;
        var _taskTrackerData$getT2 = taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT3 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT3 === void 0 ? void 0 : _taskTrackerData$getT3.endNowButton[0],
          projectId = _taskTrackerData$getT2.projectId,
          projectName = _taskTrackerData$getT2.projectName,
          taskId = _taskTrackerData$getT2.taskId,
          taskName = _taskTrackerData$getT2.taskName;
        setAddedShow({
          projectId: projectId,
          projectName: projectName,
          taskId: taskId,
          taskName: taskName
        });
      } else if (taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getT4 = taskTrackerData.getTaskTrackerDetails) !== null && _taskTrackerData$getT4 !== void 0 && _taskTrackerData$getT4.taskTrackerDatas[0]) {
        var _taskTrackerData$getT6;
        var _taskTrackerData$getT5 = taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT6 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT6 === void 0 ? void 0 : _taskTrackerData$getT6.taskTrackerDatas[0],
          _projectId = _taskTrackerData$getT5.projectId,
          _projectName = _taskTrackerData$getT5.projectName,
          _taskId = _taskTrackerData$getT5.taskId,
          _taskName = _taskTrackerData$getT5.taskName;
        setAddedShow({
          projectId: _projectId,
          projectName: _projectName,
          taskId: _taskId,
          taskName: _taskName
        });
      }
    }
  }, [taskTrackerData]);
  React.useEffect(function () {
    if (projectParameterCheck !== null) {
      var _projectListing$proje;
      var projectNameData = projectListing === null || projectListing === void 0 ? void 0 : (_projectListing$proje = projectListing.projectsListing) === null || _projectListing$proje === void 0 ? void 0 : _projectListing$proje.projects.find(function (p) {
        return p.projectId === projectParameterCheck.value;
      });
      taskList.splice(0, taskList.length);
      if (projectParameterCheck.label === "All Project") {
        var _projectListing$proje2;
        projectListing === null || projectListing === void 0 ? void 0 : (_projectListing$proje2 = projectListing.projectsListing) === null || _projectListing$proje2 === void 0 ? void 0 : _projectListing$proje2.projects.map(function (item) {
          var projectName = item.projectName,
            projectId = item.projectId,
            tasks = item.tasks;
          tasks === null || tasks === void 0 ? void 0 : tasks.map(function (data) {
            return taskList.push({
              label: data.taskName,
              value: data.taskId
            });
          });
        });
      } else {
        var _projectNameData$task;
        projectNameData === null || projectNameData === void 0 ? void 0 : (_projectNameData$task = projectNameData.tasks) === null || _projectNameData$task === void 0 ? void 0 : _projectNameData$task.map(function (data) {
          return taskList.push({
            label: data.taskName,
            value: data.taskId
          });
        });
      }
    }
  }, [projectParameterCheck]);
  React.useEffect(function () {
    var _projectListing$proje3, _projectListing$proje4;
    projectListing === null || projectListing === void 0 ? void 0 : (_projectListing$proje3 = projectListing.projectsListing) === null || _projectListing$proje3 === void 0 ? void 0 : _projectListing$proje3.projects.map(function (item) {
      var projectName = item.projectName,
        projectId = item.projectId;
      return projectList.push({
        label: projectName,
        value: projectId
      });
    });
    projectListing === null || projectListing === void 0 ? void 0 : (_projectListing$proje4 = projectListing.projectsListing) === null || _projectListing$proje4 === void 0 ? void 0 : _projectListing$proje4.projects.map(function (item) {
      var projectName = item.projectName,
        projectId = item.projectId,
        tasks = item.tasks;
      if (projectId === (addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId)) {
        tasks === null || tasks === void 0 ? void 0 : tasks.map(function (data) {
          if (projectId === (addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId)) {
            return taskList.push({
              label: data.taskName,
              value: data.taskId
            });
          }
        });
      }
    });
  }, [addedShow]);
  var manualHandleShow = function manualHandleShow(value) {
    setManualViewerShow(value);
  };
  var handleClose = function handleClose() {
    setManualViewerShow(false);
    setManualStartDate(new Date());
    setModalValueStartTime(undefined);
    setModalValueEndTime(undefined);
  };
  var handleChange = function handleChange(e) {
    setIsTaskDatePickerOpen(!isTaskDatePickerOpen);
    setTaskStartDate(e);
  };
  var handleClick = function handleClick(data) {
    setIsToggleShow(data);
  };
  var _useMutation = useMutation(ADD_TIMER_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addTimerDetails = _useMutation2[0],
    addTimerDetailsLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(ADD_MANUAL_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    addManualDetails = _useMutation4[0],
    addManualDetailsLoading = _useMutation4[1].loading;
  var _useMutation5 = useMutation(END_TIMER_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    endTimerDetails = _useMutation6[0],
    endTimerDetailsLoading = _useMutation6[1].loading;
  var handleTimerSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
      var description, variables, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // console.log(props);
            // if(!props?.userId) return;
            description = values.description;
            if ((task === null || task === void 0 ? void 0 : task.activityType) !== "break") {
              setDisableStartTask(true);
            }
            // if ((!description || !description.length) && (!addedShow || !addedShow?.projectId)) {
            //   setdescriptionError(true);
            //   setProjectError(true);
            //   return;
            // }

            // if (!description || !description.length) {
            //   setdescriptionError(true);
            //   return;
            // }
            if (!(task && !(task !== null && task !== void 0 && task.projectId) && (task === null || task === void 0 ? void 0 : task.activityType) !== "break" || !addedShow || !(addedShow !== null && addedShow !== void 0 && addedShow.projectId))) {
              _context.next = 6;
              break;
            }
            setProjectError(true);
            setDisableStartTask(false);
            return _context.abrupt("return");
          case 6:
            variables = {
              projectId: addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId,
              taskId: (addedShow === null || addedShow === void 0 ? void 0 : addedShow.taskId) || null,
              taskDescription: description,
              organisationId: organisationId,
              teamId: teamId,
              timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
            };
            _context.prev = 7;
            _context.next = 10;
            return addTimerDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: GET_TASK_TRACKER_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: props !== null && props !== void 0 && props.from ? [props === null || props === void 0 ? void 0 : props.userId] : userIds.length ? userIds : null,
                  projectId: projectIds.length ? projectIds : null,
                  taskId: taskIds.length ? taskIds : null,
                  limit: LIMIT,
                  offset: 0
                }
              }]
            });
          case 10:
            response = _context.sent;
            if (!response || !response.data || response.data.addTimerDetails === null || !response.data.addTimerDetails) {
              // throw new Error("error");
              window.location.reload(false);
            } else {
              toast.success("Timer task added successfully!");
              props.handleStart(props.activityReason || null, addedShow, values.description);
              setDisableStartTask(false);
            }
            _context.next = 16;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](7);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 14]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [addTimerDetails, addTimerDetailsLoading, addedShow]);
  var handleEndClick = React.useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, addedShow, _ref2, event) {
      var _taskTrackerData$getT7, _taskTrackerData$getT8, _taskTrackerData$getT9, _taskTrackerData$getT10;
      var resetForm, setStatus, description, taskStartTime, taskTimeId, variables, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            resetForm = _ref2.resetForm, setStatus = _ref2.setStatus;
            description = values.description, taskStartTime = values.taskStartTime, taskTimeId = values.taskTimeId;
            variables = {
              projectId: addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId,
              taskId: (addedShow === null || addedShow === void 0 ? void 0 : addedShow.taskId) || null,
              taskDescription: description,
              organisationId: organisationId,
              startTime: Number(taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT7 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT7 === void 0 ? void 0 : (_taskTrackerData$getT8 = _taskTrackerData$getT7.endNowButton[0]) === null || _taskTrackerData$getT8 === void 0 ? void 0 : _taskTrackerData$getT8.startTime) || Number(taskStartTime),
              taskTimeId: (taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT9 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT9 === void 0 ? void 0 : (_taskTrackerData$getT10 = _taskTrackerData$getT9.endNowButton[0]) === null || _taskTrackerData$getT10 === void 0 ? void 0 : _taskTrackerData$getT10.taskTimeId) || taskTimeId
            };
            _context2.prev = 3;
            _context2.next = 6;
            return endTimerDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: GET_TASK_TRACKER_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: props !== null && props !== void 0 && props.from ? [props === null || props === void 0 ? void 0 : props.userId] : userIds.length ? userIds : null,
                  projectId: projectIds.length ? projectIds : null,
                  taskId: taskIds.length ? taskIds : null,
                  limit: LIMIT,
                  offset: 0
                }
              }]
            });
          case 6:
            response = _context2.sent;
            if (!(!response || !response.data || response.data.endTimerDetails == null)) {
              _context2.next = 11;
              break;
            }
            throw new Error("error");
          case 11:
            // props.handleStop("stop");
            if (event === "stop") {
              setAddedShow(null);
              toast.success("Task ended successfully!");
              resetForm({
                description: ""
              });
              setStatus({
                success: true
              });
            }
            if (event === "stop") {
              setAddedShow(null);
            }
            taskRefetch();
            projectRefetch();
            if (event === "stop") {
              setAddedShow(null);
            }
          case 16:
            _context2.next = 20;
            break;
          case 18:
            _context2.prev = 18;
            _context2.t0 = _context2["catch"](3);
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 18]]);
    }));
    return function (_x2, _x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }(), [endTimerDetails, endTimerDetailsLoading, addedShow, taskTrackerData]);
  var handleEndClickButton = React.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(description) {
      var _taskTrackerData$getT11, _taskTrackerData$getT12;
      var variables, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            variables = {
              projectId: addedShow === null || addedShow === void 0 ? void 0 : addedShow.projectId,
              taskId: (addedShow === null || addedShow === void 0 ? void 0 : addedShow.taskId) || null,
              taskDescription: formRef.current.values.description,
              organisationId: organisationId,
              startTime: Number(taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT11 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT11 === void 0 ? void 0 : _taskTrackerData$getT11.endNowButton[0].startTime),
              taskTimeId: taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT12 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT12 === void 0 ? void 0 : _taskTrackerData$getT12.endNowButton[0].taskTimeId
            };
            _context3.prev = 1;
            _context3.next = 4;
            return endTimerDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: GET_TASK_TRACKER_QUERY,
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  userId: props !== null && props !== void 0 && props.from ? [props === null || props === void 0 ? void 0 : props.userId] : userIds.length ? userIds : null,
                  projectId: projectIds.length ? projectIds : null,
                  taskId: taskIds.length ? taskIds : null,
                  limit: LIMIT,
                  offset: 0
                }
              }]
            });
          case 4:
            response = _context3.sent;
            if (!(!response || !response.data || response.data.endTimerDetails == null)) {
              _context3.next = 9;
              break;
            }
            throw new Error("error");
          case 9:
            setAddedShow(null);
            toast.success("Task ended successfully!");
            formRef.current.resetForm({
              description: ""
            });
            formRef.current.setStatus({
              success: true
            });
          case 13:
            _context3.next = 17;
            break;
          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](1);
          case 17:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 15]]);
    }));
    return function (_x6) {
      return _ref4.apply(this, arguments);
    };
  }(), [endTimerDetails, endTimerDetailsLoading, addedShow, taskTrackerData]);
  var handleStopProjectTaskTimer = function handleStopProjectTaskTimer(values, addedShow, resetForm, setStatus, event) {
    return function () {
      try {
        if (event === "stop") {
          setDisableStartTask(true);
        }
        handleEndClick(values, addedShow, {
          resetForm: resetForm,
          setStatus: setStatus
        }, event);
        if (event === "stop") {
          setAddedShow(null);
        }
        taskRefetch();
        projectRefetch();
      } catch (error) {
        return;
      }
      if (event === "stop") {
        props === null || props === void 0 ? void 0 : props.handleProjectStop();
      } else {
        props === null || props === void 0 ? void 0 : props.handleBreak();
      }
      taskRefetch();
      projectRefetch();
      setDisableStartTask(false);
    };
  };
  if (projectListingLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (!projectListing) {
    return null;
  }

  // projectListing?.projectsListing?.projects.map((item) => {
  //   const { projectName, projectId } = item;
  //   return projectList.push({
  //     label: projectName,
  //     value: projectId,
  //   });
  // });

  // projectListing?.projectsListing?.projects.map((item) => {
  //   const { projectName, projectId, tasks } = item;
  //   if(projectId === addedShow?.projectId){
  //   tasks?.map((data) => {
  //     if(projectId === addedShow?.projectId){
  //     return taskList.push({
  //       label: data.taskName,
  //       value: data.taskId,
  //     });}
  //   });
  // }
  // });

  return /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-card",
    style: props.viewMode === "widget" ? {
      margin: 0,
      padding: "3% 3%",
      marginTop: props.task ? "2%" : "1rem",
      // marginBottom: "1rem",
      backgroundColor: props.task ? "#ffffff" : "#f3f3f3",
      borderRadius: 5,
      border: props.task ? "1px solid #eaeaea" : "none",
      marginBottom: "-1rem important"
    } : _defineProperty(_defineProperty(_defineProperty({
      margin: 0,
      width: "-webkit-fill-available"
    }, "margin", props.task ? "1rem 1rem 1rem" : "3rem"), "backgroundColor", props.task ? "#ececec" : "#ececec"), "borderRadius", 5)
  }, /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-project-card-root",
    style: props.viewMode === "widget" ? {
      padding: 0
    } : null
  }, /*#__PURE__*/React.createElement("div", {
    className: "desktop-home-project-card-root-add-section",
    style: {
      background: "#fff0",
      border: "none",
      padding: props.viewMode !== "widget" ? null : 0,
      margin: props.viewMode !== "widget" ? 16 : null,
      marginTop: props.task ? 0 : null
    }
  }, isToggleShow === "timer" ? /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      description: taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getT13 = taskTrackerData.getTaskTrackerDetails) !== null && _taskTrackerData$getT13 !== void 0 && _taskTrackerData$getT13.endNowButton[0] ? (taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT14 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT14 === void 0 ? void 0 : _taskTrackerData$getT14.endNowButton[0].taskDescription) || (props === null || props === void 0 ? void 0 : (_props$task = props.task) === null || _props$task === void 0 ? void 0 : (_props$task$projectDe = _props$task.projectDetails) === null || _props$task$projectDe === void 0 ? void 0 : _props$task$projectDe.description) || "" : (task === null || task === void 0 ? void 0 : task.taskDescription) || (taskTrackerData === null || taskTrackerData === void 0 ? void 0 : (_taskTrackerData$getT15 = taskTrackerData.getTaskTrackerDetails) === null || _taskTrackerData$getT15 === void 0 ? void 0 : (_taskTrackerData$getT16 = _taskTrackerData$getT15.taskTrackerDatas[0]) === null || _taskTrackerData$getT16 === void 0 ? void 0 : _taskTrackerData$getT16.taskDescription) || ""
    },
    enableReinitialize: true,
    validationSchema: isToggleShow === "manual" ? ManualSchema : TimerSchema,
    onSubmit: taskTrackerData !== null && taskTrackerData !== void 0 && (_taskTrackerData$getT17 = taskTrackerData.getTaskTrackerDetails) !== null && _taskTrackerData$getT17 !== void 0 && _taskTrackerData$getT17.endNowButton[0] && isToggleShow === "timer" ? handleEndClick : handleTimerSubmit,
    innerRef: formRef
  }, function (_ref6) {
    var setFieldValue = _ref6.setFieldValue,
      isSubmitting = _ref6.isSubmitting,
      values = _ref6.values;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement("div", {
      className: classNames({
        "desktop-home-project-add-card-formik": isToggleShow === "manual",
        "desktop-home-project-add-card-formik-timer": isToggleShow === "timer"
      }),
      style: props.viewMode === "widget" ? {
        display: "block"
      } : {
        justifyContent: "space-between",
        backgroundColor: "#ffffff",
        padding: 30,
        borderRadius: 5,
        paddingBottom: 12,
        paddingBlock: 20
      }
      // style={{ display: 'grid', justifyContent: 'initial' }}
    }, addedShow ? /*#__PURE__*/React.createElement(React.Fragment, null, props.viewMode === "widget" ? /*#__PURE__*/React.createElement("p", {
      style: {
        textAlign: "left",
        fontWeight: 500,
        fontSize: 18,
        width: "100%",
        marginBottom: "0.4rem",
        color: "#383838"
      }
    }, "Choose a project") : null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-added",
        className: "project-tooltip-start"
      }, addedShow.projectName)
    }, /*#__PURE__*/React.createElement(Dropdown, {
      show: isNavClick,
      className: classNames("desktop-home-project-formik-add-project-button-secondary", {
        "desktop-home-project-formik-add-project-button-error": projectError
      }),
      style: props.viewMode === "widget" ? {
        width: "100%",
        marginBottom: 20
      } : {
        width: props.task ? "73%" : "80%"
      }
    }, props.viewMode === "widget" ? null : /*#__PURE__*/React.createElement("p", {
      style: {
        textAlign: "left",
        fontWeight: 500,
        fontSize: 18,
        width: "100%",
        marginBottom: "0.4rem",
        color: "#383838"
      }
    }, "Choose a project"), /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basics",
      style: {
        width: "-webkit-fill-available",
        border: "1px solid #cacaca !important",
        color: "#545454 !important",
        fontSize: 18
      },
      onClick: function onClick() {
        return setNavClick(!isNavClick);
      }
    }, addedShow ?
    // ? `${addedShow.projectName ? `${addedShow.projectName}`.substring(0,`${props?.viewMode === "widget" ? 25 : 50}`) : ""} ${addedShow.taskName ? ` - ${addedShow.taskName}`.substring(0,`${props?.viewMode === "widget" ? 60 : 80}`) : ""}`
    "".concat(addedShow.projectName).substring(0, "".concat((props === null || props === void 0 ? void 0 : props.viewMode) === "widget" ? 67 : window.screen.width < 1399 ? 52 : window.screen.width > 1450 ? 80 : 57)) : "Select Project"), /*#__PURE__*/React.createElement(Dropdown.Menu, {
      style: {
        transform: "translate(-110px, 44px)} !important",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(DesktopProjectList, {
      isNavClick: isNavClick,
      setNavClick: setNavClick,
      addedShow: addedShow,
      setAddedShow: setAddedShow,
      projectListing: projectListing,
      setProjectError: setProjectError,
      from: "desktop"
    })))), props.viewMode === "widget" ? /*#__PURE__*/React.createElement("p", {
      style: {
        textAlign: "left",
        fontWeight: 500,
        fontSize: 18,
        width: "100%",
        marginBottom: "0.4rem",
        color: "#383838"
      }
    }, "Choose a task") : null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom-added",
        className: "project-tooltip-start"
      }, addedShow.taskName ? "".concat(addedShow.taskName) : "Click here to select a task")
    }, /*#__PURE__*/React.createElement(Dropdown, {
      show: isTaskClick,
      className: classNames("desktop-home-project-formik-add-project-button-secondary", {
        "desktop-home-project-formik-add-project-button-error": projectError
      }),
      style: props.viewMode === "widget" ? {
        width: "100%",
        marginBottom: 20
      } : {
        width: props.task ? "73%" : "80%"
      }
    }, props.viewMode === "widget" ? null : /*#__PURE__*/React.createElement("p", {
      style: {
        textAlign: "left",
        fontWeight: 500,
        fontSize: 18,
        width: "100%",
        marginBottom: "0.4rem",
        color: "#383838"
      }
    }, "Choose a task"), /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basics",
      style: {
        width: "-webkit-fill-available",
        border: "1px solid #cacaca !important",
        color: "#545454 !important",
        fontSize: 18
      },
      onClick: function onClick() {
        return setTaskClick(!isTaskClick);
      }
    }, addedShow ?
    // ? `${addedShow.projectName ? `${addedShow.projectName}`.substring(0,`${props?.viewMode === "widget" ? 25 : 50}`) : ""} ${addedShow.taskName ? ` - ${addedShow.taskName}`.substring(0,`${props?.viewMode === "widget" ? 60 : 80}`) : ""}`
    "".concat(addedShow.taskName ? "".concat(addedShow.taskName) : "Click here to select a task").substring(0, "".concat((props === null || props === void 0 ? void 0 : props.viewMode) === "widget" ? 67 : window.screen.width < 1399 ? 52 : window.screen.width > 1450 ? 80 : 57)) : "Select Task"), /*#__PURE__*/React.createElement(Dropdown.Menu, {
      style: {
        transform: "translate(-110px, 44px)} !important",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(DesktopTaskList, {
      isNavClick: isNavClick,
      setTaskClick: setTaskClick,
      setNavClick: setNavClick,
      addedShow: addedShow,
      setAddedShow: setAddedShow,
      projectListing: projectListing,
      setProjectError: setProjectError,
      from: "desktop"
    }))))) : /*#__PURE__*/React.createElement(Dropdown
    // open={isNavClick}
    , {
      className: classNames("desktop-home-project-formik-add-project-button-secondary", {
        "desktop-home-project-formik-add-project-button-error": projectError
      }),
      style: props.viewMode === "widget" ? {
        width: "100%",
        marginBottom: 20
      } : {
        width: props.task ? "73%" : "80%"
      }
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basics",
      style: {
        width: "-webkit-fill-available",
        border: "1px solid #cacaca !important",
        color: "#545454 !important",
        fontSize: 18
      }
      // onClick={() => setNavClick(!isNavClick)}
    }, addedShow ?
    // ? `${addedShow.projectName ? `${addedShow.projectName}`.substring(0,`${props?.viewMode === "widget" ? 25 : 50}`) : ""} ${addedShow.taskName ? ` - ${addedShow.taskName}`.substring(0,`${props?.viewMode === "widget" ? 60 : 80}`) : ""}`.substring(0,`${props?.viewMode === "widget" ? 60 : 80}`)
    "".concat(addedShow.projectName, " ").concat(addedShow.taskName ? " - ".concat(addedShow.taskName) : "").substring(0, "".concat((props === null || props === void 0 ? void 0 : props.viewMode) === "widget" ? 80 : window.screen.width > 1450 ? 180 : 100)) : "+ Select Project & Task"), /*#__PURE__*/React.createElement(Dropdown.Menu, {
      style: {
        transform: "translate(-110px, 44px)} !important",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(ProjectAndTaskList, {
      isNavClick: isNavClick,
      setNavClick: setNavClick,
      addedShow: addedShow,
      setAddedShow: setAddedShow,
      projectListing: projectListing,
      setProjectError: setProjectError,
      from: "desktop"
    })))), /*#__PURE__*/React.createElement(Field, {
      name: "description"
    }, function (fieldProps) {
      var _fieldProps$field = fieldProps.field,
        field = _fieldProps$field === void 0 ? task === null || task === void 0 ? void 0 : task.taskDescription : _fieldProps$field,
        meta = fieldProps.meta;
      // if (field.value.length) {
      //   setdescriptionError(false);
      // }
      return /*#__PURE__*/React.createElement(Form.Group, {
        className: "desktop-home-project-add-card-formik-description",
        style: props.viewMode === "widget" ? {
          width: "100%"
        } : {
          width: "100%",
          backgroundColor: "#fff",
          paddingBottom: 30,
          marginBottom: "0rem"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          "float": "left",
          fontWeight: 500,
          fontSize: 18,
          marginBottom: "0.4rem",
          color: "#383838",
          marginLeft: (props === null || props === void 0 ? void 0 : props.viewMode) === "widget" ? null : "1.8rem"
        }
      }, "What are you working on ?"), /*#__PURE__*/React.createElement(Field
      // className="desktop-text-input"
      , _extends({
        as: Form.Control,
        name: "description",
        type: "text",
        placeholder: "Add a comment"
      }, field, {
        style: props.viewMode !== "widget" ? {
          backgroundColor: "#fff",
          marginLeft: "1.8rem",
          width: "96%"
        } : null
      })), (!props.task || (props === null || props === void 0 ? void 0 : props.status) === "stop") && props.viewMode !== "widget" ? /*#__PURE__*/React.createElement(Button, {
        size: "md",
        variant: "primary"
        // className="mx-1 font-weight-bold"
        ,
        onClick: function onClick() {
          handleTimerSubmit(values), taskRefetch(), projectRefetch();
        }
        // onClick={props.handleStop("stop")}
        ,
        style: props.viewMode === "widget" ? {
          width: "50%",
          height: 40,
          fontSize: 20
        } : {
          fontSize: 17,
          width: "20%",
          marginTop: 32
        }
        // disabled={!hasPermission || !navigator.onLine}
        // disabled={!addedShow?.projectId && !addedShow?.taskId || !addedShow?.taskId}
        ,
        disabled: disableStartTask
      }, disableStartTask ? /*#__PURE__*/React.createElement(Spinner, {
        as: "span",
        animation: "border",
        size: "md",
        role: "status",
        "aria-hidden": "true"
      }) : "Start Task") : null);
    }), (!props.task || (props === null || props === void 0 ? void 0 : props.status) === "stop") && props.viewMode === "widget" ? /*#__PURE__*/React.createElement(Button, {
      size: "md",
      variant: "primary"
      // onClick={handleTimerSubmit}
      ,
      onClick: function onClick() {
        handleTimerSubmit(values), taskRefetch(), projectRefetch();
      },
      style: props.viewMode === "widget" ? {
        marginTop: "4%",
        width: "12rem",
        fontSize: 20
      } : {
        marginTop: "1%",
        width: "12rem",
        fontSize: 20
      }
      //  disabled={!hasPermission}
      // type="submit"
      // disabled={!addedShow?.projectId && !addedShow?.taskId || !addedShow?.taskId}
      ,
      disabled: disableStartTask
    }, disableStartTask ? /*#__PURE__*/React.createElement(Spinner, {
      as: "span",
      animation: "border",
      size: "md",
      role: "status",
      "aria-hidden": "true"
    }) : "Start Task") : /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center",
      style: {
        justifyContent: "space-evenly",
        marginBottom: 10,
        backgroundColor: props.viewMode === "fullscreen" ? "#fff" : null,
        paddingBottom: props.viewMode === "fullscreen" ? 30 : null
      }
    }, props.task && props.viewMode === "widget" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      variant: (task === null || task === void 0 ? void 0 : task.activityType) === "start" ? "outline-info" : "info",
      className: "break-button",
      onClick: (task === null || task === void 0 ? void 0 : task.activityType) === "break" ? function () {
        handleTimerSubmit(values), props !== null && props !== void 0 && props.handleBreak(), taskRefetch(), projectRefetch();
      } : handleStopProjectTaskTimer(values, addedShow, formRef.resetForm, formRef.setStatus, "break")
      // onClick={props.handleStop("stop")}
      ,
      style: props.viewMode === "widget" ? {
        width: "40%",
        height: 40,
        marginTop: 20,
        // backgroundColor: "#d65965",
        // border: "#d65965",
        borderColor: (task === null || task === void 0 ? void 0 : task.activityType) === "start" ? "#fd7e14" : null,
        color: (task === null || task === void 0 ? void 0 : task.activityType) === "start" ? "#fd7e14" : null,
        fontSize: 20
      } : {
        fontSize: 20
      }
      // disabled={!hasPermission || !navigator.onLine}
      // disabled={disableStartTask}
    }, (task === null || task === void 0 ? void 0 : task.activityType) === "start" ? "Take a Break" : "Resume Task"), /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      variant: "outline-danger",
      className: "stop-button",
      onClick: handleStopProjectTaskTimer(values, addedShow, formRef.resetForm, formRef.setStatus, "stop")
      // onClick={props.handleStop("stop")}
      ,
      style: props.viewMode === "widget" ? {
        width: "40%",
        height: 40,
        marginTop: 20,
        // backgroundColor: "#d65965",
        // border: "#d65965",
        fontSize: 20
      } : {
        fontSize: 20
      }
      // disabled={!hasPermission || !navigator.onLine}
      // disabled={disableStartTask}
    }, "End Task")) : null, props.task && props.viewMode === "fullscreen" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      size: "md",
      variant: (task === null || task === void 0 ? void 0 : task.activityType) === "start" ? "outline-info" : "info",
      className: "break-button",
      onClick: (task === null || task === void 0 ? void 0 : task.activityType) === "break" ? function () {
        handleTimerSubmit(values), props !== null && props !== void 0 && props.handleBreak(), taskRefetch(), projectRefetch();
      } : handleStopProjectTaskTimer(values, addedShow, formRef.resetForm, formRef.setStatus, "break")
      // onClick={props.handleStop("stop")}
      ,
      style: props.viewMode === "widget" ? {
        width: "50%",
        height: 40,
        fontSize: 20,
        borderColor: (task === null || task === void 0 ? void 0 : task.activityType) === "start" ? "#fd7e14" : null,
        color: (task === null || task === void 0 ? void 0 : task.activityType) === "start" ? "#fd7e14" : null
      } : {
        fontSize: 17,
        width: "20%",
        borderColor: (task === null || task === void 0 ? void 0 : task.activityType) === "start" ? "#fd7e14" : null,
        color: (task === null || task === void 0 ? void 0 : task.activityType) === "start" ? "#fd7e14" : null
      }

      // disabled={!hasPermission || !navigator.onLine}
      // disabled={disableStartTask}
    }, (task === null || task === void 0 ? void 0 : task.activityType) === "start" ? "Take a Break" : "Resume Task"), /*#__PURE__*/React.createElement(Button, {
      size: "md",
      variant: "outline-danger",
      className: "stop-button",
      onClick: handleStopProjectTaskTimer(values, addedShow, formRef.resetForm, formRef.setStatus, "stop")
      // onClick={props.handleStop("stop")}
      ,
      style: props.viewMode === "widget" ? {
        width: "50%",
        height: 40,
        fontSize: 20
      } : {
        fontSize: 17,
        width: "20%"
      }

      // disabled={!hasPermission || !navigator.onLine}
      // disabled={disableStartTask}
    }, "End Task")) : null), props.viewMode !== "widget" ? /*#__PURE__*/React.createElement(ManualPages, {
      from: "desktop",
      userId: props === null || props === void 0 ? void 0 : props.userId,
      displayName: props === null || props === void 0 ? void 0 : props.displayName,
      handleTimerSubmit: handleTimerSubmit,
      projectRefetch: projectRefetch,
      taskRefetch: taskRefetch,
      handleStopProjectTaskTimer: handleStopProjectTaskTimer(values, addedShow, formRef.resetForm, formRef.setStatus, "stop"),
      setAddedShow: setAddedShow,
      currentWorkingStatus: task === null || task === void 0 ? void 0 : task.activityType
    }) : null));
  }) : null)));
};
export default DesktopTaskTimer;